import apiRequest from './handler';

const PromptService = {

    getDispositions: async ( setIsAuthenticated, navigate ) => {
        try {
            const response = apiRequest(
                `/support/dispositions`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    getPrompts: async (enquiry_id, setIsAuthenticated, navigate) => {
        try {
            let queryParams = new URLSearchParams();
            if (enquiry_id) {
                queryParams.append('enquiry_id', enquiry_id);
            }
            let query = queryParams.toString();
            const response = apiRequest(
                `/support/prompt?${query}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    createPrompt: async (prompt, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/prompt`,
                'post',
                prompt,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    sendReminder: async (payload, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/send-reminder`,
                'post',
                payload,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    setPriority: async (payload, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/set-priority`,
                'post',
                payload,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    getRejectReasons: async (setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/reject-reasons`,
                'get',
                null,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    rejectEnquiry: async (payload, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/reject-enquiry`,
                'post',
                payload,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    }
};

export default PromptService;
